import * as z from "zod/v4";
import { returnsAnalyticsDataQualitySchema } from "./returns-analytics-shared";

export const getReturnsOwnerPerformanceInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
});
export type GetReturnsOwnerPerformanceInput = z.infer<
  typeof getReturnsOwnerPerformanceInputSchema
>;

const ownerRowSchema = z.object({
  ownerId: z.string(),
  ownerName: z.string(),
  ownerEmail: z.string().nullable(),
  totalDeals: z.number().int().min(0),
  closedWon: z.number().int().min(0),
  closedLost: z.number().int().min(0),
  winRatePct: z.number().min(0).max(100).nullable(),
  avgDealSizeCents: z.string(),
  avgTimeToCloseDays: z.number().min(0).nullable(),
  selfServeCloseCount: z.number().int().min(0),
});
export type ReturnsOwnerRow = z.infer<typeof ownerRowSchema>;

export const getReturnsOwnerPerformanceOutputSchema = z.object({
  owners: z.array(ownerRowSchema),
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsOwnerPerformanceOutput = z.infer<
  typeof getReturnsOwnerPerformanceOutputSchema
>;

export const getReturnsOwnerPerformance = {
  name: "getReturnsOwnerPerformance" as const,
  input: getReturnsOwnerPerformanceInputSchema,
  output: getReturnsOwnerPerformanceOutputSchema,
};
